<template>
  <modal
    :title="$t('SearchVinsModal.title')"
    @close-request="$emit('close-request')"
    closable
  >
    <table-element
      :isShowFilter="true"
      :title="$t('SearchVinsModal.searchedOrders')"
      :fields="fieldsObj"
      :arrOfElement="arrOfOrder"
      :sortSpacing="0"
      class="card mx-2 my-4"
    >
      <template #header-actions>
        <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{arrOfOrder.length}}</p>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="index"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'transfered': order.status === 'Transférée'
          }">
          <td class="pt-2">
            <router-link
              :to="getOrderRoute(order)"
              class="text-kne-orange nowrap"
            >
              {{ order.orderNumber }}
            </router-link>
          </td>
          <td>
             <span class="nowrap">
              {{ order.vin }}
            </span>
          </td>
          <td>
             <span class="nowrap">
              {{ $realName(order, 'transmitter') }}
            </span>
          </td>
          <td>
             <span class="nowrap">
              {{ $realName(order, 'receiver') }}
            </span>
          </td>
          <td>
             <span class="nowrap">
              {{ $realName(order, 'payer') }}
            </span>
          </td>
          <td>
            <span class="nowrap">
              {{ order.status }}
            </span>
          </td>
        </tr>
      </template>
    </table-element>
  </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import regularInput from '../../basic-components/regularInput.vue'

export default {
  name: 'SearchVinsModal',
  components: {
    TableElement,
    regularInput,
    Modal
  },

  data () {
    return {
      fieldsObj: [
       {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.VIN'),
         type: 'vin',
         value: ''
       },
       {
          text: this.$t('OrderCurrent.pickup'),
          type: 'transmitterName',
          value: ''
        },
        {
          text: this.$t('OrderCurrent.delivery'),
          type: 'receiverName',
          value: ''
        },
        {
          text: this.$t('OrderCurrent.billing'),
          type: 'payerName',
          value: ''
        },
        {
          text: this.$t('OrderCurrent.status'),
          type: 'status',
          value: ''
        }
      ]
    }
  },

  props: {
    isOpen: Boolean,
    arrOfOrder: {
      type: Array,
      required: true
    }
  },

  methods: {
    getOrderRoute (order) {
      if (order.isArchived) {
        return {
          name: 'OrderInfo',
          query: { orderId: order.orderNumber, archive: false, archivedOrder: true }
        }
      }
      return {
        name: 'OrderInfo',
        query: { orderId: order.orderNumber }
      }
    }
  }
}
</script>

<style>

</style>
